'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Box = ({ as = "div", ...props }) => {
    const Tag = as;
    return React__default['default'].createElement(Tag, Object.assign({}, props));
};

module.exports = Box;
